// externals
import type { Reducer } from 'redux';

// interfaces/types
import type { AnyFSA } from '@makemydeal/dr-browser-utils';
import type { BaggageEntry, BaggageFuelEconomyPayload } from '@makemydeal/dr-dash-bff-types';
import type { BaggageFuelEconomyState } from '@makemydeal/dr-dash-types';
import { bootstrapActionTypes } from '@makemydeal/dr-shared-store';

import { OFFER_SAVE_SUCCESS } from '../actionTypes/offerActionTypes';
import { SET_BAGGAGE_FUEL_ECONOMY } from '../actionTypes/baggageFuelEconomyActionTypes';
import { FUEL_SAVINGS_BAGGAGE_NAME } from '../constants';

export const baggageFuelEconomyInitialState: BaggageFuelEconomyState = {};
export type BaggageFuelEconomyReducer = Reducer<BaggageFuelEconomyState>;

const getPayloadFromBaggage = (baggage?: BaggageEntry[]): BaggageFuelEconomyPayload | undefined => {
    if (!Array.isArray(baggage)) {
        return undefined;
    }

    return baggage.find(({ name }: BaggageEntry) => name === FUEL_SAVINGS_BAGGAGE_NAME)?.value?.content;
};

export const reducer: BaggageFuelEconomyReducer = (
    state: BaggageFuelEconomyState = baggageFuelEconomyInitialState,
    action: AnyFSA
) => {
    switch (action.type) {
        case bootstrapActionTypes.BOOTSTRAP_SUCCESS:
        case OFFER_SAVE_SUCCESS: {
            const payload = getPayloadFromBaggage(action.payload?.baggage);

            if (!payload) {
                return state;
            }

            return {
                ...state,
                payload
            };
        }
        case SET_BAGGAGE_FUEL_ECONOMY: {
            return {
                ...state,
                payload: action.payload
            };
        }
        default: {
            return state;
        }
    }
};
